<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增菜品
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <!-- 选择餐厅 -->
          <el-form-item label="">
            <el-select v-model="queryForm.restaurantId" clearable placeholder="请选择餐厅" @change="restaurantChange" class="pr-10">
              <el-option
                v-for="item in restaurantList"
                :key="item.restaurantId"
                :label="item.title"
                :value="item.restaurantId"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 选择标签 -->
          <el-form-item label="">
            <el-select v-model="queryForm.tagId" clearable placeholder="请选择标签" class="pr-10">
              <el-option
                v-for="item in tagList"
                :key="item.tagId"
                :label="item.title"
                :value="item.tagId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              class="pr-10"
              clearable
              placeholder="关键词(搜索标题，详情等)"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="封面" show-overflow-tooltip>
        <template #default="{ row }">
          <img :src="row.basic.avatar" class="avatar" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="餐厅"
        prop="restaurant.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="上架状态"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag>{{row.step==1?'未上架':'已上架'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="价格"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ (row.basic.price && row.basic.price.defaultPrice)}}元
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="每日库存"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ (row.basic.stock && row.basic.stock.dailyStock) || '未填写' }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="总库存"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ (row.basic.stock && row.basic.stock.totalStock) || '未填写' }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="单位" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag>
            {{row.basic.unit}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleShow(row)">
            详情
          </el-button>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="{ cmd: 'edit', item: row }">
                  修改
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'copy', item: row }">
                  复制
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'delete', item: row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
    <detail ref="show" />
  </div>
</template>

<script>
import moment from 'moment'
import { findDishList, removeDish,findAll ,findTagAll} from '@/api/food'
import Edit from './edit.vue'
import Detail from './detail.vue'
export default {
  name: 'Restaurant',
  components: { Edit, Detail },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      restaurantList: [],
      tagList:[],
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        restaurantId: '',
        tagId:''
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/food/dish') {
        this.fetchData()
        this.findRestaurantAll()
        this.findTagAll()
      }
    },
  },
  created() {
    this.fetchData()
    this.findRestaurantAll()
    this.findTagAll()
  },
  methods: {
    restaurantChange(value) {
      this.tagList = []
      this.queryForm.tagId = ''
      //获取标签
      const restaurantId = this.queryForm.restaurantId
      this.findTagAll(restaurantId)
    },
    //获取餐厅列表
    async findRestaurantAll() {
      const res = await findAll()
      this.restaurantList = res || []
    },
    //获取标签列表
    async findTagAll(restaurantId) {
      const res = await findTagAll({restaurantId})
      this.tagList = res || []
    },
    handleCommand(command) {
      switch (command.cmd) {
        case 'edit':
          this.handleEdit(command.item)
          break
        case 'copy':
          this.handleCopy(command.item)
          break
        case 'delete':
          this.handleDelete(command.item)
          break
      }
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    handleCopy(row) {
      row.dishId = ''
      this.$refs['edit'].showEdit(row)
    },
    handleDelete(row) {
      this.$baseConfirm(`你确定要删除菜品：${row.title} 吗`, null, async () => {
        await removeDish({ dishId: row.dishId })
        this.$baseMessage(
          `删除菜品成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.queryData()
      })
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findDishList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
